import { z } from 'zod';

const objectIdString = z.string().regex(/^[0-9a-fA-F]{24}$/, 'Invalid ID format');

export const delegationScopeSchema = z.object({
    includeAll: z.boolean().optional(),
    entityTypes: z.array(z.string()).optional(),
    moduleKeys: z.array(z.string()).optional(),
    specificEntityIds: z.array(objectIdString).optional(),
});

/** User self-service create (delegator is always authenticated user). */
export const delegationCreateSchema = z.object({
    delegateeId: objectIdString,
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    scope: delegationScopeSchema.optional(),
    reason: z.string().max(2000).optional(),
});

/** Admin creates on behalf of another user. */
export const delegationAdminCreateSchema = delegationCreateSchema.extend({
    delegatorId: objectIdString,
});
